import { TranslationObject } from '@ngx-translate/core';

type TranslationModulePromise = Promise<{ default: TranslationObject }>;

export const TRANSLATION_LOADERS: Record<string, () => TranslationModulePromise> =
  {
    en: () =>
      import('../../../assets/i18n/en.json') as unknown as TranslationModulePromise,
    ar: () =>
      import('../../../assets/i18n/ar.json') as unknown as TranslationModulePromise,
    'ar-sa': () =>
      import(
        '../../../assets/i18n/ar-sa.json'
      ) as unknown as TranslationModulePromise,
    fr: () =>
      import('../../../assets/i18n/fr.json') as unknown as TranslationModulePromise,
    'fr-ca': () =>
      import(
        '../../../assets/i18n/fr-ca.json'
      ) as unknown as TranslationModulePromise,
    hi: () =>
      import('../../../assets/i18n/hi.json') as unknown as TranslationModulePromise,
  };

export function isSupportedTranslationLang(lang: string): boolean {
  return Object.hasOwn(TRANSLATION_LOADERS, lang);
}
